import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { Player } from '@/types/turn'

interface ListaDaOrdemProps {
  fila: string[]
  participantePorId: (id: string) => Player | undefined
  onMover: (id: string, direcao: 'cima' | 'baixo') => void
}

/**
 * A ordem da rodada, com as setas de reordenar.
 *
 * As setas têm 44px — o mínimo de alvo de toque. Na tela antiga tinham 24px
 * (`h-6 w-6`) e erravam o dedo no celular. Cada uma diz em voz alta o que faz,
 * com o nome de quem move: "Subir Ana", e não "botão".
 */
export function ListaDaOrdem({ fila, participantePorId, onMover }: ListaDaOrdemProps) {
  if (fila.length === 0) return null

  return (
    <ol className="space-y-1.5">
      {fila.map((id, indice) => {
        const participante = participantePorId(id)
        if (!participante) return null

        return (
          <li
            key={id}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-card border border-border"
          >
            <span className="flex-shrink-0 w-6 h-6 rounded bg-primary/10 flex items-center justify-center">
              <span className="text-xs font-bold text-primary">{indice + 1}</span>
            </span>

            <span className="flex-1 min-w-0 text-sm font-medium text-foreground truncate">
              {participante.name}
            </span>

            <span className="flex-shrink-0 flex">
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-11 w-11 motion-reduce:transition-none"
                aria-label={`Subir ${participante.name}`}
                disabled={indice === 0}
                onClick={() => onMover(id, 'cima')}
              >
                <ChevronUp className="h-5 w-5" />
              </Button>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-11 w-11 motion-reduce:transition-none"
                aria-label={`Descer ${participante.name}`}
                disabled={indice === fila.length - 1}
                onClick={() => onMover(id, 'baixo')}
              >
                <ChevronDown className="h-5 w-5" />
              </Button>
            </span>
          </li>
        )
      })}
    </ol>
  )
}
